// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__YCGrr","inner":"Footer_inner__1omiN"};